// Camera reports are partial. Students never submit activation claims.
export function robotReportPolicy(store, user, reports, now = Date.now()) {
  if (user.isStudent && (store._robotReconciliationEnabled || store._robotReconciliationPolling)) {
    return { readOnly: true, claims: {} };
  }
  const owner = user.isAdmin || (user.isTeacher && user.currentUser &&
    String(user.currentUser._id) === String(store.classRoomCreatedBy));
  const collectExisting = owner && store._robotReconciliationPolling && !store._robotReconciliationEnabled;
  if (collectExisting && !store._robotPendingReports) store._robotPendingReports = new Map();
  const claims = Object.entries(reports).reduce((result, [mac, identifier]) => {
    const current = store.classRoomRobots.get(mac);
    const needsVerification = collectExisting && current && current.numberVerified === false;
    if (needsVerification || !current || String(current.identifier) !== String(identifier)) {
      if (collectExisting) {
        const previous = store._robotPendingReports.get(mac);
        if (previous && String(previous.identifier) === String(identifier) && now - previous.at < 5000) return result;
        store._robotPendingReports.set(mac, { identifier, at: now });
      }
      result[mac] = identifier;
    }
    return result;
  }, {});
  return { readOnly: false, claims };
}
